import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { ISourceRegistryRequestModel, ISourceRegistryResponseModel } from '../../../models';
import { getSourceRegistryResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

/**
 * Custom hook to call update source registry api
 * @returns promise
 */
const useUpdateSourceRegistry = () => {
  async function callUpdateSourceRegistry(sourceRegistryData: ISourceRegistryRequestModel, source: string, version: string) {
    const resp = await apiWrapper.put<ISourceRegistryResponseModel, { errorMessage: string }
    >(
      `${process.env.REACT_APP_API_CONTROL_PLANE_SOURCE_REGISTRY_URL}/sources/${source}/version/${version}`,
      sourceRegistryData,
      headersInstance()
    );
    /**
    * @method apiResult
    * @description Validating the api response using joi.
    */
    const apiResponse = getSourceRegistryResponseSchema.validate(resp.responseBody, {
      abortEarly: true
    });

    if (apiResponse.error) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: true
      };
    }
    let responseData = <ISourceRegistryResponseModel>{};
    if (resp.responseBody) {
      responseData = resp.responseBody;
    }
    return {
      updateSourceRegistryData: responseData,
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const updateSourceRegistry = (sourceRegistryData: ISourceRegistryRequestModel, source: string, version: string) => callUpdateSourceRegistry(sourceRegistryData, source, version);

  return { updateSourceRegistry };
};

export default useUpdateSourceRegistry;
